"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaleRate = void 0;
var usePool_1 = require("../../pool/hooks/usePool");
var utils_1 = require("../../shared/utils");
function useSaleRate() {
    var pool = (0, usePool_1.usePool)().pool;
    var rate = pool.sale.rate, decimals = pool.fundToken.decimals;
    var value = (0, utils_1.toWeiBN)(1);
    var currencyPerToken = (0, utils_1.tokensToCurrency)({
        value: value,
        rate: rate,
        decimals: decimals,
    });
    var tokensPerCurrency = (0, utils_1.currencyToTokens)({ value: value, rate: rate, decimals: decimals });
    return { currencyPerToken: currencyPerToken, tokensPerCurrency: tokensPerCurrency };
}
exports.useSaleRate = useSaleRate;
